<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="chapter002">
<h1 class="chapter-title"><a href="#/toc#Ref_11921a" id="Ref_11921"><span>YOU CAN GO IN NOW, BUT PLEASE DON’T</span></a></h1>
<p class="noindent"><span class="dropcaps">M</span><span>y grandfather was a colonel in the Rangers. My grandmother was a fine Army wife and very smart. One of the things she taught me is that God can do anything except change a man’s mind. “That’s why there are wars,” she said, and knew the subject well. In two wars she had lost a husband, two sons, and a daughter, leaving her with just my mother, who was thirty when her sister died. “Men are so goddamned stubborn they will insult, curse, and shout until they can’t back down, and then decide it’s time to send our children out to die. The fellows who order up wars almost never go themselves, they’re too old. But they’re still cowards. If you’re a leader and you screw up a war, or maybe if you just</span> <em>start</em><span> a war, you should blow your brains out right in front of all the Gold Star mothers, sitting on bleachers in their Sunday best—and that’s what</span> <em>I</em><span> say, but don’t quote me, okay? This kind of talk upsets your mother.”</span></p>
<p><span>Until I was eight and my mother and father divorced, we lived on or around military bases. I bounced through five or six concrete blockhouse schools and hated every minute of it. My mother believed in the goodness of the human race. As if in spite, the human race tried with all its might to prove her wrong. After her divorce, she jonesed for handsome, crazy men and usually ended up with cashiered ex-Army or bank robbers. I thought I had to protect her. Or at least I remember thinking that; maybe it just turned out that way. None of that stopped me from enlisting to become a Skyrine, but now it haunts me.</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?fc390ce0